import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@savgroup-front-common/primitive/ui/drawer';

import { SelectSellerControl } from '../SelectSellerControl/SelectSellerControl';

import messages from './messages';

interface SelectSellerDrawerProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onSelected: () => void;
  dataTestId?: string;
}

export const SelectSellerDrawer: FC<SelectSellerDrawerProps> = ({
  isOpen,
  onOpenChange,
  onSelected,
  dataTestId,
}) => {
  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange}>
      <DrawerContent data-testid={dataTestId} className="max-h-[85vh]">
        <DrawerHeader>
          <DrawerTitle>
            {safeFormattedIntlString(messages.selectSeller)}
          </DrawerTitle>
        </DrawerHeader>

        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-4 pb-6">
          <SelectSellerControl
            onClose={() => {
              onOpenChange(false);
              onSelected();
            }}
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
